import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import imgBPst from '../../img/STRAPPINGTOOL/BatteryPoweredST.jpg'
import imgSst from '../../img/STRAPPINGTOOL/SteelST.jpg'
import imgPPst from '../../img/STRAPPINGTOOL/PPst.jpeg'


export const PetST = () => {
    const des = {

        imgBPst: ['Strap Width - 13-16 Adjustable', 'Strap Thickness - 0.5-1.0', 'Weight - 3.9 kg', 'Size - 375 * 130 *140', 'Tension - 40-200', 'Type of Seal - Friction Weld', 'Strap Material - Pet/pp', 'Battery - Up to 200 cycles with', 'one battery charge',
        ],
        imgSst: ['Strap Width - 13-16-19mm', 'Item Code - A-333',
            'Strap thickness - 0.38-0.58', 'items in Pack - 1PCS ', 'Net Weight - 3.8 KG ',
        ],
        imgPPst:['STRAP WIDTH-13-19 ADJUSTABLE','STRAP THICKNESS-1.0-1.5','WEIGHT-3.8','SIZE-275*115*130','TENSION-200','TYPE OF SEAL-FRICTION WELD','PRESSURE-5-7 BAR','STRAP MATERIAL-PET/PP','BATTERY-N/A','NET WEIGHT-3.8KG',
            ]


    }
    return (
        <div className='prdmain'>
            <div className='head2'>
                <h1>Pet Strapping Tool</h1>
            </div>
            <div className='items1'>
                <Prodcard1
                    imageSrc={imgBPst}
                    model={"VP 101BPT"}
                    title="Battery Powered Strapping Tool"
                    altText="img of websit"
                    description={des.imgBPst}
                />
                <Prodcard1
                    imageSrc={imgSst}
                    model={"VP 19 SST"}
                    title="Steel Strapping Tool"
                    altText="img of websit"
                    description={des.imgSst}
                />
                 <Prodcard1
                    imageSrc={imgPPst}
                    model={"VP 101 PNT"}
                    title="Pnumatic Strapping Tool"
                    altText="img of websit"
                    description={des.imgPPst}
                />

            </div>


        </div>
    )
}
